<template>
    <div
    v-if="show"
    class="the-restore-banner absolute flex justify-center faa-fade faa-opti"
    :class="{ 'faa-fade-in': showRestoreBanner }">
        <p>Heureux de vous retrouver ! Vous souhaitez reprendre votre parcours là où vous l'avez laissé ?</p>

        <!-- Switch -->
        <label class="switch cursor-pointer">
            <input type="checkbox" @click="restoreLastPage">
            <span class="slider round"></span>
        </label>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'TheRestoreBanner',
        data() {
            return {
                show: false,
                showRestoreBanner: false,
            }
        },
        computed: {
            ...mapState('Auth', [ 'userInfo' ]),
        },
        watch: {
            showRestoreBanner:{
                handler(show) {
                    if (show) {
                        this.show = true
                    } else {
                        setTimeout(() => {
                            this.show = show
                        }, 250)
                    }
                },
                immediate: true,
            },
            'userInfo.lastPage': {
                handler(lastPage) {
                    if (lastPage && lastPage.data && lastPage.data.name && lastPage.data.name != 'Home') {
                        this.showRestoreBanner = true
                    }
                },
                immediate: true,
            },
            $route: {
                handler(to) {
                    // Hide when going to another page
                    if (to.name != 'Home') {
                        this.showRestoreBanner = false
                    }
                },
                immediate: true,
            },
        },
        methods: {
            restoreLastPage() {
                this.showRestoreBanner = false

                if (this.userInfo.lastPage) {
                    const lastRoute = this.$router.resolve(this.userInfo.lastPage.data).route

                    this.$router.push(lastRoute)
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

.the-restore-banner {
    @apply bg-blue-dark text-white font-bold rounded-t-btn m-auto py-6;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 58rem;

    p {
        @apply mr-4;
    }
}

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
    margin-bottom:0;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    @apply border border-gray-lighter bg-gray-lighter;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    @apply border-blue bg-blue;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 24px;
}

.slider.round:before {
    border-radius: 50%;
}

</style>
